// Styles
import style from './Loading.module.css'

// Stores
import useSourceStore from '../../Store/SourceStore.js'

export default function Loading(props){

    const loading = useSourceStore((state)=> state.loading)

    if(!loading){
        return(
            <div className={style['container']}>
            </div>
        )
    }

    return(
        <div className={style['container']}>
            <img src={loading && loading} alt={'loading'}/>
        </div>
    )
}